<script setup>
import { cn } from '@/lib/utils';
import { buttonVariants } from '@/components/ui-nova/button';

// Warianty klas pochodzą z shadcn-vue (styl reka-nova) — jedno źródło stylu
// przycisku dla całej aplikacji. API komponentu bez zmian (variant/size/class).
const props = defineProps({
    variant: {
        type: String,
        default: 'default',
        validator: (v) => ['default', 'destructive', 'outline', 'secondary', 'ghost', 'link'].includes(v),
    },
    size: {
        type: String,
        default: 'default',
        validator: (v) => ['default', 'xs', 'sm', 'lg', 'icon', 'icon-xs', 'icon-sm', 'icon-lg'].includes(v),
    },
    disabled: Boolean,
    class: String,
});
</script>

<template>
    <button
        type="button"
        data-slot="button"
        :data-variant="variant"
        :data-size="size"
        :disabled="disabled"
        :class="cn(buttonVariants({ variant: props.variant, size: props.size }), props.class)"
    >
        <slot />
    </button>
</template>
